module.exports = __webpack_public_path__ + "static/1-afcf866554f27579f89f07efe2e97158.jpg";